<button mat-raised-button color="primary" [routerLink]="['/garantia/',idPersona,'nuevo']">
    <mat-icon>add</mat-icon>
    Nueva garantia 
</button>